module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/190-uzbekistn-961bbc1dce283565338bb549b303774d.svg";